export default __webpack_public_path__ + "static/media/14.139e1832.webp";